import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-themify',
  templateUrl: './themify.component.html',
  styleUrls: ['./themify.component.scss']
})

/**
 * Themify component - handling the themify icon with navbar and content
 */
export class ThemifyComponent implements OnInit {
  // bread crumb items
  breadCrumbItems: Array<{}>;

  constructor() { }

  ngOnInit() {
    this.breadCrumbItems = [{ label: 'Aivis', path: '/' }, { label: 'Icons', path: '/' }, { label: 'Themify', path: '/', active: true }];

  }

}
